import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-office-labour-inner-tab',
  templateUrl: './office-labour-inner-tab.component.html',
  styleUrls: ['./office-labour-inner-tab.component.scss']
})
export class OfficeLabourInnerTabComponent implements OnInit {
@Input() projectId:number;
@Input() approveStatus:any = [];
  constructor() { }

  ngOnInit() {
   // console.log(this.projectId);
  }

}
